export const getRowKey = (record) => record.sonarObjectId;
